import React from 'react';
import { format12HourTime } from '../utils/formatters';
import { isCompletedMatch } from '../utils/match';

const MatchGamesList = ({ match }) => {

  const isCompleted = isCompletedMatch(match);
  const team1Name = match.team_1_name;
  const team2Name = match.team_2_name;

  // Create a local copy of games with results instead of mutating props
  let gamesWithResults = [];

  if (isCompleted) {
    if (!match.metadata) {
      return <div className="no-matches">No game information available</div>;
    }
    const team1GameResults = match.teams.find(team => team.designation === 1).results;
    const team2GameResults = match.teams.find(team => team.designation === 2).results;

    // Create a new array instead of modifying the original
    gamesWithResults = match.metadata.games.map(game => {
      const gameNumber = game.game_number;
      const team1GameResult = team1GameResults.find(result => result.game_number === gameNumber);
      const team2GameResult = team2GameResults.find(result => result.game_number === gameNumber);

      // Return a new game object with the result added
      return {
        ...game,
        result: {
          team_1_score: team1GameResult.goals,
          team_2_score: team2GameResult.goals,
          winner: team1GameResult.result > team2GameResult.result ? 1 : 2
        }
      };
    });
  } else {
    if (!match.match_format.metadata) {
      return <div className="no-matches">No game information available</div>;
    }
  }

  return (
    <div className="games-list">
      {isCompleted ? gamesWithResults.map(game => {
        // For completed matches with results
        if (isCompleted && game.result) {
          // No "Winner: X" column — the score states it, and the winning name
          // is already emphasised while the loser recedes.
          return (
            <div key={game.game_number} className="game-item">
              <div className="game-number">Game {game.game_number}</div>
              <div className="game-result">
                <span className={game.result.winner === 1 ? 'game-winner' : 'game-loser'}>
                  {team1Name}
                </span>
                <span className="game-score">
                  {game.result.team_1_score} - {game.result.team_2_score}
                </span>
                <span className={game.result.winner === 2 ? 'game-winner' : 'game-loser'}>
                  {team2Name}
                </span>
              </div>
              {game.map_name && <div className="game-map">{game.map_name}</div>}
            </div>
          );
        }
      }) : match.match_format.metadata.map(game => {
        // For upcoming matches
        const gameTime = format12HourTime(game.est_time);

        return (
          <div key={game.game_number} className="game-item">
            <div className="game-number">Game {game.game_number}</div>
            <div className="game-result">
              <span>{team1Name}</span>
              <span className="vs">VS</span>
              <span>{team2Name}</span>
            </div>
            <div className="game-time">
              Scheduled: {gameTime}
            </div>
          </div>
        );
      })
      }
    </div>
  );
};

export default MatchGamesList;
